import { render } from "./Feedback.vue?vue&type=template&id=75077707&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=75077707&lang=scss&scoped=true"
import "./Feedback.vue?vue&type=style&index=1&id=75077707&lang=scss"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75077707"]])

export default __exports__